import FieldSkeleton from '@api/order/components/CellLoaders/FieldSkeleton'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { CATEGORY_INTERNAL_SEPERATOR } from '@components/UI-Components/HierarchyWiseItems/constants'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import HierarchyCell from '@modules/order/components/CellTemplates/components/HierarchyCell/HierarchyCell'
import last from 'lodash/last'
import get from 'lodash/result'
import React, { FC } from 'react'
import { makeStyles } from '@material-ui/core'
import useViewContext from '@modules/order/hooks/use-view-context'

const useStyles = makeStyles(theme => ({
  heirarchyLabel: {
    paddingRight: 5,
    textTransform: 'capitalize'
  }
}))

const EnhancedHeirarchyName: FC<CellItem> = ({ rowData, column }) => {
  const classes = useStyles()
  const { uiStore } = useViewContext()
  if (!rowData) {
    return (
      <HierarchyCell>
        <FieldSkeleton />
      </HierarchyCell>
    )
  }
  const hierarchy: any = last(uiStore.getHierarchy(rowData?.name))
  const value = get(hierarchy, column?.field) ?? ''
  const isMainHeirarchy = !rowData?.[column?.field]?.includes(CATEGORY_INTERNAL_SEPERATOR)
  return (
    <HierarchyCell>
      <div
        style={{
          marginLeft: 10 * rowData.depth
        }}
      >
        <Typography
          variant={isMainHeirarchy ? 'h6' : 'caption'}
          className={classes.heirarchyLabel}
        >
          {`${value}`.toLowerCase()}
        </Typography>
      </div>
    </HierarchyCell>
  )
}

export default EnhancedHeirarchyName
